module.exports = __webpack_public_path__ + "img/yizhanshi1.dd1ab1c5.png";